export enum AppCategoryEnum {
  OTHER = 1,
  PMS = 2,
  GUEST_APP = 3,
  ACCESS_CONTROL = 4,
}

export enum AppStatusEnum {
  DRAFT = 1,
  REJECTED = 2,
  PRIVATE = 3,
  TEST = 4,
  PUBLISHED = 5,
  INTERNAL = 6,
  BLOCKED = 7,
  IN_REVIEW = 8,
}

export enum AppInternalIdentifierEnum {
  WEMA_LEISURE = 1,
  BOOKING_EXPERTS = 2,
  GREAT_STAY_APP = 3,
  CAMPING_CARE = 4,
  RECRANET = 5,
  TOMMY_BOOKING_SUPPORT = 6,
  TOMM_BOOKING_SUPPORT = 7,
  TENZER = 8,
  CAMPING_COMFORT = 9,
  GUEST_REPORTS = 10,
  /** Catalog record for the Verbleif MCP server; installs bind MCP-host tokens, never an auth-server client. */
  VERBLEIF_MCP = 11,
  /**
   * Hidden platform app for the Staff MCP server: personal installs of Verbleif staff, never in the catalog. Its
   * structure (auth method, OAuth client, scopes, owner) is fixed by the API; only its listing is editable.
   */
  VERBLEIF_STAFF_MCP = 12,
}

export enum AppTypeEnum {
  OUTBOUND = 1,
  INBOUND = 2,
}

export enum AppSubscriptionAuthDataTypeEnum {
  Generic = "AppSubscription.AuthData.Generic",
  Oauth = "AppSubscription.AuthData.OAuth",
  TommyBookingSupport = "AppSubscription.AuthData.TommyBookingSupport",
  ApiKey = "AppSubscription.AuthData.ApiKey",
  BasicAuth = "AppSubscription.AuthData.BasicAuth",
}

export enum AppSubscriptionLocationDataTypeEnum {
  Generic = "AppSubscriptionLocationSetting.Data.Generic",
  BookingExperts = "AppSubscriptionLocationSetting.Data.BookingExperts",
  TommyBookingSupport = "AppSubscriptionLocationSetting.Data.TommyBookingSupport",
  TommBookingSupport = "AppSubscriptionLocationSetting.Data.TommBookingSupport",
  GuestReport = "AppSubscriptionLocationSetting.Data.GuestReport",
  CampingCare = "AppSubscriptionLocationSetting.Data.CampingCare",
  Recranet = "AppSubscriptionLocationSetting.Data.Recranet",
}

export enum AppDataDocumentTypeEnum {
  Generic = "App.Data.Generic",
  OAuth = "App.Data.OAuth",
  InboundOAuth = "App.Data.InboundOAuth",
  InboundApiKey = "App.Data.InboundApiKey",
  InboundWebhook = "App.Data.InboundWebhook",
}

/**
 * Per-app rate-limit policy. Values match the Symfony RateLimiter policy strings exactly so the
 * backend can pass them straight through to the runtime limiter factory (plan §7.1).
 */
export enum AppRateLimitPolicyEnum {
  NoLimit = "no_limit",
  FixedWindow = "fixed_window",
  SlidingWindow = "sliding_window",
  TokenBucket = "token_bucket",
}

export enum AppWebhookConfirmationMethodEnum {
  WaitForSuccess = "wait_for_success",
  FireAndForget = "fire_and_forget",
}

export enum AppWebhookDeliveryStateEnum {
  Fired = "fired",
  AwaitingConfirmation = "awaiting_confirmation",
  Confirmed = "confirmed",
  Failed = "failed",
}

export enum AppInboundAuthEnum {
  OAuth = "oauth",
  ApiKey = "api_key",
}

export enum AppAuthDataDocumentTypeEnum {
  OAuth = "App.AuthData.OAuth",
}

export enum AppSubscriptionDataTypeEnum {
  BookingExperts = "AppSubscription.Data.BookingExperts",
  Generic = "AppSubscription.Data.Generic",
  CampingCare = "AppSubscription.Data.CampingCare",
}
